<template>
    <div class="data-container">
        <div class="tool-box">
            <el-button type="primary" :icon="Refresh" @click="resetQueryForm">刷新</el-button>
            <el-button type="primary" plain :icon="Plus" @click="onAddClick()" v-permission="['clsss:type:add']">添加</el-button>
            <el-button
                type="primary"
                plain
                :icon="DCaret"
                @click="onSortClick(batchPatchRoomType)"
                v-permission="['clsss:type:sort']"
            >
                一键排序
            </el-button>
            <el-button type="primary" :icon="Upload" plain @click="uploadVisible = true" v-permission="['clsss:type:upload']">
                导入
            </el-button>
            <el-button
                type="primary"
                :icon="Download"
                plain
                @click="onExportClick('房间类型')"
                v-permission="['clsss:type:exprot']"
            >
                导出
            </el-button>
        </div>
        <el-form :inline="true" class="search-form" :model="queryForms" label-position="top">
            <el-form-item label="类型名称">
                <el-input v-model="queryForms.name" placeholder="请输入类型名称"></el-input>
            </el-form-item>
            <el-form-item label="类型编码">
                <el-input v-model="queryForms.code" placeholder="请输入类型编码"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" :icon="Search" plain @click="getTableData">搜索</el-button>
                <el-button :icon="Refresh" @click="resetQueryForm">重置</el-button>
            </el-form-item>
        </el-form>
        <el-table class="data-table" :data="table_data" v-loading="tableLoading" scrollbar-always-on>
            <el-table-column label="序号" width="80" type="index" />
            <el-table-column label="类型名称" prop="name"></el-table-column>
            <el-table-column label="类型编码" prop="code"></el-table-column>
            <el-table-column prop="list_order" label="显示顺序" width="150">
                <template #default="scope">
                    <el-input-number
                        style="width: 100px"
                        type="number"
                        v-model="scope.row.list_order"
                        :min="0"
                        :max="999999"
                        controls-position="right"
                        size="small"
                    />
                </template>
            </el-table-column>
            <el-table-column label="是否预设" prop="preset">
                <template #default="{ row }">
                    {{ row.preset ? '是' : '否' }}
                </template>
            </el-table-column>
            <el-table-column label="备注" prop="remark">
                <template #default="{ row }">
                    {{ row.remark ? row.remark : '-' }}
                </template>
            </el-table-column>
            <el-table-column label="更新时间" prop="update_time"></el-table-column>
            <el-table-column label="操作" fixed="right" width="220">
                <template #default="{ row }">
                    <el-button type="primary" link :icon="View" @click="onShowClick(row)" v-permission="['clsss:type:view']">
                        详情
                    </el-button>
                    <el-button
                        v-if="!row.preset"
                        type="primary"
                        link
                        :icon="Edit"
                        @click="onEditClick(row)"
                        v-permission="['clsss:type:edit']"
                    >
                        编辑
                    </el-button>
                    <el-button
                        v-if="!row.preset"
                        type="primary"
                        link
                        :icon="Delete"
                        @click="onRemoveClick({ data: row, api: delRoomType })"
                        v-permission="['clsss:type:del']"
                    >
                        删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            class="pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[15, 30]"
            :page-size="page_size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
        ></el-pagination>
        <forms-dialog
            v-model="formDialogVisible"
            :isForm="isForm"
            :typeId="selectMacId"
            @updateForm="getTableData"
        ></forms-dialog>
        <imports-form v-if="uploadVisible" v-model="uploadVisible" @updateForm="getTableData" menuCode="room/type"></imports-form>
    </div>
</template>

<script setup>
import { onMounted, ref, watch } from 'vue'
import { DCaret, Delete, Download, Edit, Plus, Refresh, Search, Upload, View } from '@element-plus/icons'
import { batchPatchRoomType, delRoomType, getRoomTypeLists } from '@/api/roomType.js'
import FormsDialog from './components/forms.vue'
import ImportsForm from '@/components/ImportsForm.vue'
import useTable from '@/hooks/useTable'

// 重置
const resetQueryForm = () => {
    Object.keys(queryForms.value).forEach((key) => {
        queryForms.value[key] = ''
    })
    getTableData()
}

// 数据源
const queryForms = ref({
    name: '',
    code: ''
})
const {
    page,
    page_size,
    total,
    table_data,
    tableLoading,
    getTableData,
    onRemoveClick,
    onSortClick,
    handleSizeChange,
    handleCurrentChange,
    onExportClick
} = useTable(getRoomTypeLists, queryForms.value)

const formDialogVisible = ref(false)
const isForm = ref(false) // 是否是表单
const selectMacId = ref('') // 点中的模块id
// 保证每次打开重新获取数据
watch(formDialogVisible, (val) => {
    if (!val) selectMacId.value = ''
})

// 查看
const onShowClick = (row) => {
    isForm.value = false
    if (row.pid == null) {
        selectMacId.value = row.id
        formDialogVisible.value = true
    } else {
        selectMacId.value = row.pid
    }
}
// 编辑
const onEditClick = (row) => {
    isForm.value = true
    selectMacId.value = row.id
    formDialogVisible.value = true
}

// 添加
const onAddClick = () => {
    isForm.value = true
    selectMacId.value = ''
    formDialogVisible.value = true
}

const uploadVisible = ref(false)

// 切换到前台时候执行
onMounted(() => {
    getTableData()
})
</script>

<style scoped></style>
